export const getReorderAnchor = <T,>(items: T[], sourceIndex: number, destinationIndex: number): T | null => {
    if (sourceIndex === destinationIndex) {
        return null;
    }
    const withoutDragged = items.filter((_, index) => index !== sourceIndex);
    const anchorIndex = destinationIndex > sourceIndex ? destinationIndex - 1 : destinationIndex;
    return withoutDragged[anchorIndex] ?? null;
};